<template>
  <b-col class="col-12 p-0 py-2 border-bottom">
    <div class="d-flex align-items-center justify-content-between">
      <div class="d-flex align-items-center attachment-left">
        <b-avatar
          v-if="!file.uuid"
          :key="updateAvatarKey"
          :src="imgOrvid(file.preview.preview)"
          :text="txtExt(file.preview.preview)"
          square
          class="avatar-preview-sample"
        />

        <div v-else>
          <b-avatar
            v-if="!isVideo(file.preview.preview)"
            :key="updateAvatarKey"
            :src="verifyAsset(file.preview.preview)"
            :text="txtExt(file.preview.preview)"
            square
            class="avatar-preview-sample"
          >
            <img
              v-if="isImage(file.preview.preview)"
              :src="verifyAsset(file.preview.preview)"
              @error="errorLoad(file)"
              class="w-100 h-100"
            />
          </b-avatar>
          <video v-else :src="verifyAsset(file.preview.preview)" class="avatar-preview-sample"></video>
        </div>

        <strong v-if="!file.uuid" class="attachment-title">
          <span v-if="file.preview.name && file.preview.name.length > 0" class="attachment-title-text">
            {{ file.preview.name }}
          </span>
          <span v-else class="text-muted attachment-title-text">{{ $t('creator.noCaption') }}</span>
        </strong>
        <strong v-else class="text-muted attachment-title">
          <span class="attachment-title-text">{{ $t('creator.upFile') }}</span>
        </strong>
      </div>

      <b-button variant="flat-secondary" @click="$emit('delete', file)" class="attachment-trash">
        <feather-icon icon="TrashIcon" size="20"></feather-icon>
      </b-button>
    </div>

    <b-dropdown class="w-100 mt-1" menu-class="w-100" variant="flat-secondary">
      <template #button-content>
        {{ file.asset_type ? file.asset_type.text : $t('creator.assetType') }}
      </template>
      <b-dropdown-item
        v-for="item in assetTypes"
        :key="item.value"
        @click="$emit('set-asset-type', { file, assetType: item })"
      >
        <div class="d-flex align-items-center text-wrap">
          <div class="d-flex">
            <b-icon :icon="item.icon" class="mr-05"></b-icon>
            <div>
              <strong>{{ item.text }}</strong>
              <p class="avenir-medium m-0">{{ item.description }}</p>
            </div>
          </div>
        </div>
      </b-dropdown-item>
    </b-dropdown>
  </b-col>
</template>

<script>
import {
  BCol,
  BButton,
  BAvatar,
  BDropdown,
  BDropdownItem,
  BIcon,
} from 'bootstrap-vue'
import { isVideo } from '@/libs/utils/formats'

export default {
  name: 'AttachmentFileItem',
  components: {
    BCol,
    BButton,
    BAvatar,
    BDropdown,
    BDropdownItem,
    BIcon,
  },
  props: {
    file: {
      type: Object,
      required: true,
    },
    assetTypes: {
      type: Array,
      required: true,
    },
    updateAvatarKey: {
      type: [String, Number, Boolean, Object],
      default: null,
    },
    verifyAsset: {
      type: Function,
      required: true,
    },
    imgOrvid: {
      type: Function,
      required: true,
    },
    txtExt: {
      type: Function,
      required: true,
    },
    isImage: {
      type: Function,
      required: true,
    },
    errorLoad: {
      type: Function,
      required: true,
    },
  },
  data() {
    return {
      isVideo,
    }
  },
}
</script>

<style scoped lang="scss">
.text-wrap {
  flex-flow: wrap;
}
.avatar-preview-sample {
  width: 45px;
  height: 45px;
  object-fit: cover;
  border-radius: 1em !important;
  margin: 0 1em 0 0;
}
.attachment-left {
  flex: 1 1 auto;
  min-width: 0;
  overflow: hidden;
}
.attachment-title {
  flex: 1 1 auto;
  min-width: 0;
  overflow: hidden;
}
.attachment-title-text {
  display: block;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
}
.attachment-trash {
  flex: 0 0 auto;
  flex-shrink: 0;
}
.mr-05 {
  margin-right: 0.5em;
}
</style>
